import { JsonpClientBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { InvocaService } from 'src/app/base/services/invoca.service';
import { Curso } from '../interfaces/curso';
import { Postulacion } from '../interfaces/postulacion';
import { Postulante } from '../interfaces/postulante';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class PostulacionesService {

  constructor(
    private invoke: InvocaService,
    private sessionService: SessionService,
    private messageService: MessageService
  ) {}

  async ingresarPostulacion(postulante: Postulante, postulacion: Postulacion): Promise<any> {
    let resp;
    await this.invoke.httpInvoke('public/ingresarPostulacion', { postulante: postulante, postulacion: postulacion })
    .then(res => {
      if (res.status && res.status === 'ERROR') {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: res.data });
      } else {
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: res.data });
      }
      resp = res;
    })
    return resp;
  }

  
  async obtenerNivelesEstudio() {
    return this.invoke.httpInvoke('getNivelesEstudio');

  }

  async obtenerPreguntasPostulacion(curso_id: number) {
    return this.invoke.httpInvoke('public/getPreguntasPostulacion', { curso_id: curso_id});
  }

  async obtenerPostulacionesUsuario() {
    return this.invoke.httpInvoke('postulaciones/getPostulacionesUsuario');
  }

  async getCantidadPostulacionesAlumno() {
    return this.invoke.httpInvoke('postulaciones/getCantidadPostulacionesAlumno');
  }

  async getCantidadPostulacionesAceptadasAlumno() {
    return this.invoke.httpInvoke('postulaciones/getCantidadPostulacionesAceptadasAlumno');
  }

  async getCantidadPostulaciones() {
    return this.invoke.httpInvoke('public/getCantidadPostulaciones');
  }

  

}
